import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const extractMonths = (identifier) => {
    const match = identifier?.match(/(\d+)/);
    return match ? parseInt(match[1], 10) : 0;
};

const useDynamicPlanOptions = (selectedPackages) => {
    const packageDetailsMap = useSelector((state) => state.PriceSimulationReducer.packageDetailsMap);

    return useMemo(() => {
        if (!selectedPackages?.length || !packageDetailsMap) return [];

        const planMap = new Map();
        selectedPackages.forEach((pkg) => {
            const plans = packageDetailsMap[pkg.id]?.availablePlans;
            if (plans) {
                plans.forEach((plan) => {
                    if (plan.identifier) {
                        planMap.set(plan.identifier, { id: plan.identifier, name: plan.name });
                    }
                });
            }
        });

        return Array.from(planMap.values()).sort(
            (a, b) => extractMonths(a.id) - extractMonths(b.id)
        );
    }, [selectedPackages, packageDetailsMap]);
};

export default useDynamicPlanOptions;
